<div class="msg-style">
    <h4>{{'session_expired_Notice'|translate}}</h4>
</div>